import { WifiOff } from "lucide-react";

import { useAppStatus } from "@/hooks/use-banner-data";

import { Banner } from "./banner";

export const OfflineBanner = () => {
  const { isOnline } = useAppStatus();

  if (isOnline) return null;

  return (
    <Banner
      icon={<WifiOff size={16} />}
      message="You appear to be offline. Please check your internet connection to continue."
    />
  );
};
